import "./LeakDetectionRepair.module.css";
import Header from "@/reusable_sections/Header";
import LeakHero from "./sections/LeakHero";
import LeakDetection from "./sections/LeakDetection";
import LeakTypes from "./sections/LeakTypes";
import LeakWarnings from "./sections/LeakWarnings";
import ServicesGrid from "./sections/ServicesGrid";
import Categories from "./sections/Categories";
import ServiceArea from "./sections/ServiceArea";
import LeakFaq from "./sections/LeakFaq";
import Leakdetectionservicerequest from "./sections/Leakdetectionservicerequest";
import Emergencycta from "./sections/Emergencycta";
import Footer from "@/reusable_sections/Footer";
export default function LeakDetectionRepairPage() {
  return <div>
      <Header />
      <LeakHero />
      <LeakDetection />
      <LeakTypes />
      <LeakWarnings />
      <ServicesGrid />
      <Categories />
      <ServiceArea />
      <LeakFaq />
      <Leakdetectionservicerequest id="leak-detection-service-request-form" />
      <Emergencycta />
      <Footer />
    </div>;
}